import { css } from 'styled-components';


const COMPARISON_BREAK_POINT = '1280px';

const HIDE_COMPARISON_IF_MOBILE = css`
    @media screen and (max-width: ${COMPARISON_BREAK_POINT}) {
        display: none;
    }
`;

const SHOW_COMPARISON_IF_MOBILE = css`
    @media screen and (min-width: ${COMPARISON_BREAK_POINT}) {
        display: none;
    }
`;

export { SHOW_COMPARISON_IF_MOBILE };
export default HIDE_COMPARISON_IF_MOBILE;
